import React from 'react'
import PropTypes from 'prop-types'

const FilterFormSections = props => {
  const { handleSectionClicked, unassignedKey, allSections, checkedSections } =
    props

  return (
    <div className="multi-state-choice-field">
      <input
        className="form-control multi-state-choice-field-control"
        id="course-sections"
        name="course-sections"
        type="hidden"
        value=""
      />
      <ul className="multi-state-choice-field-list">
        <li
          className="multi-state-choice-field-item d-flex"
          onClick={() => handleSectionClicked(unassignedKey)}
        >
          {checkedSections.includes(unassignedKey) ? (
            <div className="multi-state-choice-field-state active">
              <div className="icon icon_checkbox_checked2 icon_color_primary" />
            </div>
          ) : (
            <div className="multi-state-choice-field-state active">
              <div className="icon icon_checkbox_unchecked" />
            </div>
          )}
          <div className="multi-state-choice-field-text ml-2">
            Unassigned Students
          </div>
        </li>
        {allSections.map((section, i) => (
          <li
            className="multi-state-choice-field-item d-flex"
            onClick={() => handleSectionClicked(section)}
            key={i}
          >
            {checkedSections.includes(section) ? (
              <div className="multi-state-choice-field-state active">
                <div className="icon icon_checkbox_checked2 icon_color_primary" />
              </div>
            ) : (
              <div className="multi-state-choice-field-state active">
                <div className="icon icon_checkbox_unchecked" />
              </div>
            )}
            <div className="multi-state-choice-field-text ml-2">{section}</div>
          </li>
        ))}
      </ul>
    </div>
  )
}

FilterFormSections.propTypes = {
  unassignedKey: PropTypes.string.isRequired,
  allSections: PropTypes.array.isRequired,
  checkedSections: PropTypes.array.isRequired,
  handleSectionClicked: PropTypes.func.isRequired,
}

export default FilterFormSections
